// autopop.ts -- Patch 015.40-W1 wizard inline panel surface for the
// existing 012.B autopop endpoint. Re-fires Census + DNR + parcel
// lookups against the project's address; writes new project_facts
// rows. The wizard's Set-address panel calls this when the operator
// asks to (re-)run autopop without leaving the wizard.

import { request } from './request'

export interface AutopopRunInput {
  street: string
  city: string
  state: string
  zip: string
  sources?: Array<
    | 'census_geocoder'
    | 'parcel'
    | 'dnr_pwi'
    | 'jurisdiction'
    | 'jurisdiction_profile'
    | 'subdivision'
    | 'manual_override'
  >
}

export interface AutopopRunResponse {
  ok: true
  facts_written: number
  facts_skipped: number
  sources_ran: string[]
  sources_failed: Array<{ source: string; error: string }>
  request_id: string
}

export const autopopApi = {
  run: (projectId: string, body: AutopopRunInput) =>
    request<AutopopRunResponse>(
      `/api/projects/${encodeURIComponent(projectId)}/autopop`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
}
